import {easeInQuart} from 'modules/ease.js';

export default function () {

    return easeInQuart;
};
